<template>
  <div id="">
    <div class="row-reservation">
      <div class="depart-by-date with-button" data-circuitid="482">
        <div
          class="depart-logo"
          :style="{
            background: 'url(' + trip.Elem_Image_Card + ')',
            backgroundPosition: 'center center',
          }"
        >
          <div class="temps-restant-container" v-if="isActive === 1 && trip.Countdown_Mois && trip.Countdown_Jours">
            <span class="title-temps"> Votre départ est dans : </span>
            <div class="temps-restant">
              <div class="decompte-restant">
                <span class="nbr-restant">{{ trip.Countdown_Mois }}</span>
                Mois
              </div>
              <div class="decompte-restant">
                <span class="nbr-restant">{{ trip.Countdown_Jours }}</span>
                Jours
              </div>
            </div>
          </div>
        </div>

        <div class="depart-infos">
          <div class="depart-title" :style="{ color: trip.Elem_Couleur }">
            {{ trip.NomBase }}
          </div>
          <div class="depart-sub-title">{{ trip.Description }}<br /></div>
          <div class="circuit-duration">
            <img class="calendar" src="../assets/calendrier.svg" />
            {{ trip.Jours_Circuit }}
          </div>

          <ul class="incontournables">
            <li v-for="(Incontournable, index) in Incontournables" :key="index">
              {{ Incontournable }}
            </li>
          </ul>

          <div class="depart-date">
            <div
              class="depart-title"
              :style="{ color: trip.Elem_Couleur }"
              v-if="isActive !== 0"
            >
              Date du départ :
            </div>
            <div
              class="depart-title"
              :style="{ color: trip.Elem_Couleur }"
              v-if="isActive === 0"
            >
              Date :
            </div>
            <ul class="list-depart">
              <li>
                <a>
                  {{ trip.Date_Texte }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row-consultation-reservation">
        <div class="button-evl">
          <button class="boutonConfirm" v-if="isActive === 1" @click="toTrip">
            Consulter cette réservation
          </button>
          <button
            class="boutonConfirm"
            v-if="isActive === 0"
            @click="toSouvenir"
          >
            Consulter ce voyage
          </button>
          <button class="boutonConfirm" v-if="isActive === 2 && trip.participant.Etat_Formulaire === 1" :disabled="true">
            En attente d'approbation
          </button>
          <button class="boutonConfirm" v-if="isActive === 2  && trip.participant.Etat_Formulaire !== 1" @click="toInscription">
            Compléter l'inscription
          </button>
        </div>
        <div
          class="document-consultation"
          v-if="
            trip.participant &&
            trip.participant.Validation_NouveauxDocuments === 1
          "
        >
          <img class="warning" src="../assets/warning.svg" />
          <p>Nouveau document à consulter</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "",
  props: {
    trip: Object,
    isActive: Number,
  },
  computed: {
    ...mapState({
      triplist: (state) => state.triplist.list,
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    ...mapActions(["refreshToken"]),
    toTrip() {
      this.$router.push({
        name: "trip",
        params: { id: this.trip.a__pk },
      });
    },
    toSouvenir() {
      this.$router.push({
        name: "trip",
        params: { id: this.trip.a__pk },
        query: { mode: "souvenir" },
      });
    },
    toInscription() {
      window.location.href = "https://www.voyages-lambert.com/inscription-gform/?departid="+this.trip.a_fk_WordPressID+"&token="+this.user.token+"&refresh="+this.user.refresh_token;
    },
  },
  mounted() {
    this.Incontournables = JSON.parse(this.trip.Incontournables);
    this.refreshToken({token:this.user.refresh_token})

  },
  data: () => ({
    Incontournables: [],
  }),
};
</script>
<style lang="css" scoped>
.title {
  font-size: 20px;
  font-weight: bold;
}
.carte {
  cursor: pointer;
}
.carte:hover .imageCarte {
  -webkit-transform: scale(0.8);
  transform: scale(1.1);
}
.carte:hover {
  -webkit-transform: scale(0.8);
  transform: scale(1.05);
}
.redtext {
  color: red;
}
.imageCarte {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  min-height: 250px;
  position: relative;
  cursor: pointer;
}
</style>
